import { render, staticRenderFns } from "./VentasPorAnio.vue?vue&type=template&id=5551584b&"
import script from "./VentasPorAnio.vue?vue&type=script&lang=js&"
export * from "./VentasPorAnio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports